import { useQueryClient } from '@tanstack/react-query';

import type { CommonMutationOptions } from '../../../common/types/Common';
import { getMembershipBillsQueryKey } from './useMembershipBills';

// Common mutation options used to trigger a refetch of membership bills
export const useRefetchBillsMutationOptions = (
    membershipId: string,
): CommonMutationOptions => {
    const queryClient = useQueryClient();
    const billsKeyPrefix = getMembershipBillsQueryKey({
        membershipId,
    });

    return {
        onMutate: async () => {
            await queryClient.cancelQueries({
                predicate: (query) => {
                    const key = query.queryKey[0];
                    return (
                        typeof key === 'string' &&
                        (key === billsKeyPrefix ||
                            key.startsWith(`${billsKeyPrefix}/`))
                    );
                },
            });
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                predicate: (query) => {
                    const key = query.queryKey[0];
                    return (
                        typeof key === 'string' &&
                        (key === billsKeyPrefix ||
                            key.startsWith(`${billsKeyPrefix}/`))
                    );
                },
            });
        },
        onSettled: () => {},
    };
};
